import React from 'react';
import * as ReactDOM from 'react-dom';

type Props = {
    children: React.ReactNode,
    closeWindowCallback: () => void,
    modalClass?: string,
    bodyStyle?: any,
}

const modalRoot = document.getElementById('popup-container');

export default class Modal extends React.Component<Props> {

    componentDidMount() {
        document.getElementsByTagName('body')[0].classList.add('modal-open');
        document.documentElement.style.overflow = 'hidden';
    }
    componentWillUnmount() {
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
        document.documentElement.style.overflow = '';
    }

    render() {
        const {
            children,
            closeWindowCallback,
            modalClass,
            bodyStyle,
        } = this.props;

        return ReactDOM.createPortal(
            (
                <div
                    className={`modal ${modalClass || ''}`}
                    style={{ display: 'flex' }}
                    onClick={() => closeWindowCallback()}
                    onKeyPress={() => {}}
                    role="presentation"
                >
                    <div className="modal-dialog" onClick={e => e.stopPropagation()} role="presentation">
                        <div className="modal-content">
                            <div className="modal-body" style={bodyStyle}>
                                <button type="button" className="close" onClick={() => closeWindowCallback()}>
                                    <span>&times;</span>
                                </button>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            modalRoot!,
        );
    }
}
